module.exports = {"header":"Kundecases","subheader":"Et udsnit af de løsninger, som vi har leveret.","vwType":"Landingside","vwText":"Beskrivelse","qType":"Reservedelsplatform - Webshop","qText":"Beskrivelse","jhType":"Donationsplatform - Hjemmeside","jhText":"Beskrivelse","apmpType":"Landingside","apmpText":"Beskrivelse","gwType":"Hjemmeside","gwText":"Beskrivelse","otherTitle":"Andre referencer","otherText":"Vi har også hjulpet disse virksomheder med diverse web-opgaver"}


//////////////////
// WEBPACK FOOTER
// ./src/app/case/lang/da.lang.json
// module id = 333
// module chunks = 1